import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
import store from "../store/index.js"
Vue.use(Router)
const routes = [{
    path: '/',
    name: 'totalAnalyze',
    component: (resolve) => require(['@/pages/home/TotalAnalyze.vue'], resolve),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: (resolve) => require(['@/pages/Login'], resolve),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/home',
    component: Layout,
    children: [{
      path: 'totalAnalyze',
      component: (resolve) => require(['@/pages/home/TotalAnalyze.vue'], resolve),
      name: 'totalAnalyze',
      meta: {
        title: '二衬'
      }
    }, ]
  },

  {
    path: '/constructionManagement/',
    component: Layout,
    children: [{
        path: 'flatnessAnalysis',
        component: (resolve) => require(['@/pages/constructionManagement/FlatnessAnalysis.vue'], resolve),
        name: 'flatnessAnalysis',
        meta: {
          title: '初支平整度'
        }
      },
      {
        path: 'secQualityAnalysis',
        component: (resolve) => require(['@/pages/constructionManagement/SecQualityAnalysis.vue'], resolve),
        name: 'secQualityAnalysis',
        meta: {
          title: '二衬质量分析'
        }
      },
      {
        path: 'volumeSquareAnalysis',
        component: (resolve) => require(['@/pages/constructionManagement/VolumeSquareAnalysis.vue'], resolve),
        name: 'volumeSquareAnalysis',
        meta: {
          title: '二衬方量'
        }
      }, {
        path: 'initialThicknessAnalysis',
        component: (resolve) => require(['@/pages/constructionManagement/InitialThicknessAnalysis.vue'], resolve),
        name: 'initialThicknessAnalysis',
        meta: {
          title: '初支厚度分析'
        }
      }, {
        path: 'invertedLimitAnalysis',
        component: (resolve) => require(['@/pages/constructionManagement/InvertedLimitAnalysis.vue'], resolve),
        name: 'invertedLimitAnalysis',
        meta: {
          title: '仰拱侵限分析'
        }
      },
    ]
  },
  // 考核管理
  {
    path: '/assessingManagement/',
    component: Layout,
    children: [{
        path: 'flatnessAnalysisAsses',
        component: (resolve) => require(['@/pages/assessingManagement/FlatnessAnalysisAsses.vue'], resolve),
        name: 'flatnessAnalysisAsses',
        meta: {
          title: '初支平整度考核'
        }
      },
      {
        path: 'volumeSquareAnalysisAssess',
        component: (resolve) => require(['@/pages/assessingManagement/VolumeSquareAnalysisAssess.vue'], resolve),
        name: 'volumeSquareAnalysisAssess',
        meta: {
          title: '二衬方量考核'
        }
      },
      {
        path: 'threeInspectionAssessments',
        component: (resolve) => require(['@/pages/assessingManagement/ThreeInspectionAssessments.vue'], resolve),
        name: 'threeInspectionAssessments',
        meta: {
          title: '三检考核'
        }
      },
    ]
  },
  // 系统管理
  {
    path: '/systemManagement/',
    component: Layout,
    children: [{
        path: 'deviceManager',
        component: (resolve) => require(['@/pages/systemManagement/DeviceManager.vue'], resolve),
        name: 'deviceManager',
        meta: {
          title: '设备管理'
        }
      },
      {
        path: 'SMS_Settings',
        component: (resolve) => require(['@/pages/systemManagement/SMS_Settings.vue'], resolve),
        name: 'SMS_Settings',
        meta: {
          title: '短信配置'
        }
      },
      {
        path: 'employeeManager',
        component: (resolve) => require(['@/pages/systemManagement/EmployeeManager.vue'], resolve),
        name: 'employeeManager',
        meta: {
          title: '人员管理'
        }
      },
      {
        path: 'importProject',
        component: (resolve) => require(['@/pages/systemManagement/ImportProject.vue'], resolve),
        name: 'importProject',
        meta: {
          title: '项目数据录入'
        }
      },
      {
        path: 'importSection',
        component: (resolve) => require(['@/pages/systemManagement/ImportSection.vue'], resolve),
        name: 'importSection',
        meta: {
          title: '标段数据录入'
        }
      },
      {
        path: 'importProjectSite',
        component: (resolve) => require(['@/pages/systemManagement/ImportProjectSite.vue'], resolve),
        name: 'importProjectSite',
        meta: {
          title: '工点数据录入'
        }
      },
      {
        path: 'importDeductibleSquare',
        component: (resolve) => require(['@/pages/systemManagement/ImportDeductibleSquare.vue'], resolve),
        name: 'importDeductibleSquare',
        meta: {
          title: '核算扣除方量录入'
        }
      },
      {
        path: 'effectiveRange',
        component: (resolve) => require(['@/pages/systemManagement/EffectiveRange.vue'], resolve),
        name: 'effectiveRange',
        meta: {
          title: '工点有效里程范围设置'
        }
      },
      {
        path: 'logRecord',
        component: (resolve) => require(['@/pages/systemManagement/LogRecord.vue'], resolve),
        name: 'logRecord',
        meta: {
          title: '日志记录'
        }
      },

    ]
  },
  // 阈值设置
  {
    path: '/thresholdSetting/',
    component: Layout,
    children: [{
        path: 'flatnessThreshold',
        component: (resolve) => require(['@/pages/thresholdSetting/FlatnessThreshold.vue'], resolve),
        name: 'flatnessThreshold',
        meta: {
          title: '平整度阈值'
        }
      },
      {
        path: 'volumeThreshold',
        component: (resolve) => require(['@/pages/thresholdSetting/VolumeThreshold.vue'], resolve),
        name: 'volumeThreshold',
        meta: {
          title: '方量阈值'
        }
      },
      {
        path: 'pouringThreshold',
        component: (resolve) => require(['@/pages/thresholdSetting/PouringThreshold.vue'], resolve),
        name: 'pouringThreshold',
        meta: {
          title: '浇筑时间阈值'
        }
      },
    ]
  },
  // 检测管理
  {
    path: '/detectionManagement/',
    component: Layout,
    children: [{
        path: 'detectionStatistics',
        component: (resolve) => require(['@/pages/detectionManagement/DetectionStatistics.vue'], resolve),
        name: 'detectionStatistics',
        meta: {
          title: '检测统计'
        }
      },
      {
        path: 'detectionOverdue',
        component: (resolve) => require(['@/pages/detectionManagement/DetectionOverdue.vue'], resolve),
        name: 'detectionStatistics',
        meta: {
          title: '检测逾期'
        }
      },
      {
        path: 'thirdPartyInspection',
        component: (resolve) => require(['@/pages/detectionManagement/ThirdPartyInspection.vue'], resolve),
        name: 'thirdPartyInspection',
        meta: {
          title: '第三方检测'
        }
      },
    ]
  },
  {
    path: '/defectManagement/',
    component: Layout,
    children: [{
        path: 'defectStatistics',
        component: (resolve) => require(['@/pages/defectManagement/DefectStatistics.vue'], resolve),
        name: 'defectStatistics',
        meta: {
          title: '缺陷统计'
        }
      },
      {
        path: 'problemBase',
        component: (resolve) => require(['@/pages/defectManagement/ProblemBase.vue'], resolve),
        name: 'problemBase',
        meta: {
          title: '问题库'
        }
      },
    ]
  },

]




const router = new Router({
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}
router.beforeEach((to, from, next) => {
  //路由是否需要权限验证
  const token = sessionStorage.getItem('token')
  let whiteList = ['登录']
  if (token) {
    next()
  } else {
    if (whiteList.indexOf(to.meta.title) != -1) {
      next()
    } else {
      sessionStorage.clear()
      router.replace({
        path: '/login'
      })
    }

  }


})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js